import { render, staticRenderFns } from "./cohorts.vue?vue&type=template&id=1cdc936c&scoped=true"
import script from "./cohorts.vue?vue&type=script&lang=js"
export * from "./cohorts.vue?vue&type=script&lang=js"
import style0 from "./cohorts.vue?vue&type=style&index=0&id=1cdc936c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc936c",
  null
  
)

export default component.exports